import clsx from 'clsx'
import { Skeleton } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'modules/Finance/Wallets/subcomponents/Chart/ChartSkeleton.module.scss'

export const ChartSkeleton = ({ className = '' }) => (
  <Skeleton shown className={clsx(styles['chart-skeleton'], className)}>
    <div className={styles['chart-skeleton__fig']} />
    <div className={styles['chart-skeleton__legend']}>
      <div
        className={clsx(
          styles['chart-skeleton__line'],
          styles['chart-skeleton__line_line1'],
        )}
      >
        <div
          className={clsx(
            styles['chart-skeleton__text'],
            styles['chart-skeleton__text_long'],
          )}
        />
      </div>
      <div
        className={clsx(
          styles['chart-skeleton__line'],
          styles['chart-skeleton__line_line2'],
        )}
      >
        <div className={styles['chart-skeleton__text']} />
        <div
          className={clsx(
            styles['chart-skeleton__text'],
            styles['chart-skeleton__text_long'],
          )}
        />
      </div>
      <div
        className={clsx(
          styles['chart-skeleton__line'],
          styles['chart-skeleton__line_line3'],
        )}
      >
        <div className={styles['chart-skeleton__text']} />
      </div>
    </div>
  </Skeleton>
)

ChartSkeleton.propTypes = {
  className: PropTypes.string,
}
